import graphQR from './graph-qr.container';

export default graphQR;
